@if (loading) {
  <loading class="pos-abs vh-center"></loading>
}
<div class="tw-fixed tw-left-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
  <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
</div>
@if (!loading) {
  <div class="hbox rebranding-hbox font-noto">
    <div class="flex-box">
      <div class="flex-content tw-bg-blue-200 bg-grad pos-rel" #scrollContainer="">
        <div class="tw-bg-grid-layout tw-pt-24 tw-px-4 tw-mb-4">
          @if ([appConfig.Shared.Regimen.Class.FACE, appConfig.Shared.Regimen.Class.BODY].includes(report?.type)) {
            <div class="tw-font-body tw-font-bold tw-text-700" i18n="@@skinReport">
          Skin Report
        </div>
          }
          @if (report?.type === appConfig.Shared.Regimen.Class.HAIR) {
            <div class="tw-font-body tw-font-bold tw-text-700" i18n="@@hairReport">
          Hair Report
        </div>
          }
          <div class="tw-font-body tw-font-bold tw-text-300">
            {{report?.createdAt | date: 'd MMM yyyy'}}
          </div>
        </div>
        <div class="heading">
          <div class="fontS2 mT5">
            <div i18n="@@yourReportIsCreatedBy">
            Your check-up report is created by
            <br/>
            <span class="fw-700">{{doctorInfo?.name}}'s</span> team
          </div>
          </div>
          @if (report?.doctor && report?.audioURL) {
            <section class="mT25 mB25 audio">
              <div class="card">
                <c-audio class="c-audio" src="{{report.audioURL}}" imageUrl="{{doctorInfo?.imageUrl}}" eventPrefix="Check-Up" (emitTrackEvent)="trackEvent($event)"></c-audio>
              </div>
              @if (isInternalUser && report.audioNote) {
                <div class="audioNote card">
                  <span class="bold">Audio Note:</span><span class="pL5 fontS1">{{report.audioNote}}</span>
                </div>
              }
            </section>
          }
        </div>
        <div class="content">
          <section>
            <div class="h1" i18n="@@yourTransformation">
            Your Transformation Journey
          </div>
            @for (item of comparisonSliders; track item; let i = $index) {
              <comparison-slider [index]="i" [sliderLength]="comparisonSliders.length" [report]="item" (back)="back()" [user]="user"></comparison-slider>
            }
          </section>
          @if (report?.observation) {
            <section class="note">
              <div class="h1" i18n="@@observation">Observation</div>
              <div [innerHTML]="report.observation"></div>
            </section>
          }
          @if (report?.treatmentProgress && report.treatmentProgress.length) {
            <section class="progress" #progressBar="">
              <div class="h1" i18n="@@yourTreatmentProgress">
            Your Transformation Progress
          </div>
              @for (item of report.treatmentProgress; track item; let i = $index) {
                <div class="progress-bar">
                  <div class="title">
                    {{item.issue.split('_').join(' ').toLowerCase()}}
                  </div>
                  <progress-bar [value]="item.score" [bgTemplate]="i%2" [stagesLanguageString]="progressBarStages" [animate]="animateProgressBar"></progress-bar>
                </div>
              }
            </section>
          }
          @if (report?.investigations?.name || report?.investigations?.tests?.length) {
            <section class="investigation tw-bg-gray-100 tw-text-black">
              <div class="bold fontL2" i18n="@@investigation">Investigation</div>
              <div class="mT10 fontS1" i18n="@@investigationHint">
            Kindly do the following tests to plan your treatment further and
            upload reports before next follow up.
          </div>
              <div class="tests">
                @if (report?.investigations?.name) {
                  <div class="title bold">
                    {{report?.investigations?.name}}
                  </div>
                }
                @for (item of report?.investigations.tests; track item) {
                  <div class="test">
                    {{item}}
                  </div>
                }
              </div>
            </section>
          }
          @if (report?.regimenModifications) {
            <section class="regimenModification">
              <div class="card">
                <div class="title bold" i18n="@@yourTreatmentChanged">
              Your Treatment kit has been Changed
            </div>
                @for (item of report.regimenModifications; track item) {
                  <li>{{item}}</li>
                }
                <div
                  class="tw-my-2 tw-w-full tw-bg-teal-600 tw-px-6 tw-h-[48px] tw-flex tw-items-center tw-justify-center tw-rounded-3 tw-text-white tw-text-500 tw-font-semibold"
                  (click)="viewRegimen()">
                  <span class="tw-font-body tw-tracking-normal" i18n="@@viewTreatment">View Treatment kit</span>
                </div>
              </div>
            </section>
          }
          @if (report?.tips) {
            <section class="tips">
              <div class="card">
                <div class="title">
                  <img src="https://cdn.cureskin.com/app/img/heart.svg" /><span i18n="@@importantTip">Important tip from your doctor</span>
                </div>
                <div class="tip">{{report.tips}}</div>
              </div>
            </section>
          }
          @if (report.consentFormAsk) {
            <section class="tips">
              <div class="card" (click)="openConsentForm()">
                <div class="tw-text-center" i18n="@@consentToPrescribeMedicines">
              Consent to prescribe medicines
            </div>
                <div class="consent-button" i18n="@@open">Open</div>
              </div>
            </section>
          }
          @if (showFeedbackQuestions && !afterSaveFeedback) {
            <div class="feedback-question">
              <div class="question" i18n="@@areYouSatisfiedWithTheReport?">
            Are you satisfied with the Report?
          </div>
              <div class="answer-holder">
                <div class="btn" i18n="@@yes" (click)="saveFeedback('isReportSatisfied', true)" [ngClass]="{'btn-green': feedback?.isReportSatisfied == true}">Yes</div>
                <div class="btn mL5" i18n="@@no" (click)="saveFeedback('isReportSatisfied', false)" [ngClass]="{'btn-red': feedback?.isReportSatisfied == false}">No</div>
              </div>
              <div class="question mT20" i18n="@@wereYouAbleToUnderstandTheVoiceNote?">
            Were you able to understand the Voice note?
          </div>
              <div class="answer-holder">
                <div class="btn" i18n="@@yes" (click)="saveFeedback('isVoiceNoteUnderstandable', true)" [ngClass]="{'btn-green': feedback?.isVoiceNoteUnderstandable == true}">Yes</div>
                <div class="btn mL5" i18n="@@no" (click)="saveFeedback('isVoiceNoteUnderstandable', false)" [ngClass]="{'btn-red': feedback?.isVoiceNoteUnderstandable == false}">No</div>
              </div>
              @if (followUpCount > 1) {
                <div class="question mT20" i18n="@@wereAllYourDoubts/queriesAnswered?">
            Were all your Doubts/queries answered?
          </div>
              }
              @if (followUpCount > 1) {
                <div class="answer-holder">
                  <div class="btn answer" i18n="@@yes" (click)="saveFeedback('doubtsCleared', true)" [ngClass]="{'btn-green': feedback?.doubtsCleared == true}">Yes</div>
                  <div class="btn mL5" i18n="@@no" (click)="saveFeedback('doubtsCleared', false)" [ngClass]="{'btn-red': feedback?.doubtsCleared == false}">No</div>
                </div>
              }
            </div>
          }
          <div class="feedback-section" #feedbackSection="">
            @if (afterSaveFeedback) {
              <div class="feedback card">
                <em class="cs-icon-circle-tick-plain icon"></em>
                <div class="flex-grow mL10" i18n="@@thankYouForYourFeedback">
              Thank You For Your Feedback
            </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}

<ng-template #doctorName let-name>
  <span class="fw-700">{{name}}</span>
</ng-template>
